import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import {
    CssBaseline, CircularProgress, Container, Grid, Button,
    Dialog, DialogTitle, DialogContent, DialogActions, TextField,
    FormControlLabel, Checkbox, IconButton, Tooltip
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import MyMaterialTable from '../../components/table';
import Footer from '../../components/footer';
import { injectIntl } from 'react-intl';
import SectionCard from '../../components/section-card';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import ConfirmActionDialog from '../../components/confirm-action-dialog';
import * as componentActions from '../../redux/actions/admin-billing';
import * as adminProductService from '../../services/admin-product.service';
import * as adminApplicationService from '../../services/admin-application.service';
import Api from "../../services/api";

class AdminProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            resultList: [],
            // Create/Edit dialog
            dialogOpen: false,
            dialogMode: 'create',
            dialogName: '',
            dialogId: '',
            dialogAllowedBillingModes: [1],
            dialogEditId: null,
            billingModes: [],
            nextId: 1,
            // Delete dialog
            deleteDialogOpen: false,
            deleteProductId: null,
            deleteProductName: '',
        };

        this.closeNotification = this.closeNotification.bind(this);
    }

    componentDidMount() {
        this.getItens();
        this.loadBillingModes();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state === "reload") {
            this.componentDidMount();
        }
    }

    getItens() {
        this.setState({ loading: true });

        adminProductService.getProducts(true)
            .then(result => {
                if (result.data.success) {
                    const data = result.data.data || [];
                    this.setState({ loading: false, resultList: data });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                const intl = this.props.intl;
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    loadBillingModes() {
        adminProductService.getBillingModes()
            .then(result => {
                if (result.data.success) this.setState({ billingModes: result.data.data || [] });
            })
            .catch(err => Api.kickoff(err));
    }

    loadNextId() {
        adminProductService.getNextApplicationId()
            .then(result => {
                if (result.data.success) {
                    const nextId = result.data.data?.nextid ?? result.data.data?.NextId ?? result.data.data?.nextId ?? 1;
                    this.setState({ nextId, dialogId: String(nextId) });
                }
            })
            .catch(() => {});
    }

    handleOpenCreateDialog() {
        this.loadNextId();
        this.setState({
            dialogOpen: true,
            dialogMode: 'create',
            dialogName: '',
            dialogId: '',
            dialogAllowedBillingModes: [1],
            dialogEditId: null,
        });
    }

    handleOpenEditDialog(product) {
        const modes = product.allowedbillingmodes ?? product.allowedBillingModes ?? [1];
        this.setState({
            dialogOpen: true,
            dialogMode: 'edit',
            dialogName: product.name,
            dialogId: String(product.id),
            dialogAllowedBillingModes: Array.isArray(modes) ? modes : [1],
            dialogEditId: product.id,
        });
    }

    handleCloseDialog() {
        this.setState({ dialogOpen: false });
    }

    handleToggleBillingMode(modeId) {
        this.setState(prev => {
            const current = prev.dialogAllowedBillingModes || [];
            const updated = current.includes(modeId)
                ? current.filter(id => id !== modeId)
                : [...current, modeId];
            return { dialogAllowedBillingModes: updated.length > 0 ? updated : current };
        });
    }

    handleSaveProduct() {
        const { dialogMode, dialogName, dialogId, dialogAllowedBillingModes, dialogEditId } = this.state;
        const intl = this.props.intl;

        if (!dialogName || !dialogName.trim()) {
            this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: intl.formatMessage({ id: "admin.application.name.required" }) });
            return;
        }

        const id = parseInt(dialogId);
        if (dialogMode === 'create' && (!id || id <= 0)) {
            this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: "ID é obrigatório e deve ser maior que zero" });
            return;
        }

        this.setState({ loading: true, dialogOpen: false });

        const promise = dialogMode === 'create'
            ? adminProductService.createProduct({ id, name: dialogName.trim(), allowedBillingModes: dialogAllowedBillingModes })
            : adminProductService.updateProduct({ id: dialogEditId, name: dialogName.trim(), allowedBillingModes: dialogAllowedBillingModes });

        promise
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "success",
                        notificationMessage: intl.formatMessage({ id: dialogMode === 'create' ? "admin.application.create.success" : "admin.application.edit.success" })
                    });
                    this.getItens();
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    handleOpenDeleteDialog(product) {
        this.setState({
            deleteDialogOpen: true,
            deleteProductId: product.id,
            deleteProductName: product.name,
        });
    }

    handleDeleteProduct() {
        const { deleteProductId } = this.state;
        const intl = this.props.intl;

        this.setState({ loading: true, deleteDialogOpen: false });

        adminApplicationService.deleteApplication(deleteProductId)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "success",
                        notificationMessage: intl.formatMessage({ id: "admin.application.delete.success" })
                    });
                    this.getItens();
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    render() {
        const { classes, headerMenu } = this.props;
        const intl = this.props.intl;

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='xl' style={{ paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />

                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <SectionCard
                                    context="list"
                                    title={intl.formatMessage({ id: "admin.products.title" })}
                                    actions={
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<AddIcon />}
                                            onClick={() => this.handleOpenCreateDialog()}
                                        >
                                            {intl.formatMessage({ id: "admin.application.new" })}
                                        </Button>
                                    }
                                    divider={false}
                                />
                            </Grid>
                        </Grid>

                        <MyMaterialTable
                            title=""
                            columns={[
                                { title: 'ID', field: 'id' },
                                { title: intl.formatMessage({ id: "name" }), field: 'name' },
                                {
                                    title: intl.formatMessage({ id: "admin.products.is.product" }),
                                    field: 'isproduct',
                                    render: rowData => (rowData.isproduct ?? rowData.isProduct)
                                        ? <CheckCircleIcon style={{ color: '#4caf50' }} />
                                        : <CancelIcon style={{ color: '#9e9e9e' }} />
                                },
                                {
                                    title: intl.formatMessage({ id: "actions" }),
                                    field: 'actions',
                                    render: rowData => (
                                        <div>
                                            <Tooltip title={intl.formatMessage({ id: "edit" })}>
                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); this.handleOpenEditDialog(rowData); }}>
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={intl.formatMessage({ id: "delete" })}>
                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); this.handleOpenDeleteDialog(rowData); }}>
                                                    <DeleteIcon style={{ color: '#f44336' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    )
                                },
                            ]}
                            data={this.state.resultList}
                            rowClick={(event, rowData) => {
                                this.props.addCurrentHirer(rowData);
                                this.props.history.push({
                                    pathname: `/${this.props.match.params.lang}/admin-product-detail`,
                                    state: { product: rowData }
                                });
                            }}
                        />

                        {/* Create/Edit Application Dialog */}
                        <Dialog open={this.state.dialogOpen} onClose={() => this.handleCloseDialog()} maxWidth="sm" fullWidth>
                            <DialogTitle style={{ backgroundColor: '#8BC34A', color: '#fff' }}>
                                {intl.formatMessage({ id: this.state.dialogMode === 'create' ? "admin.application.new" : "admin.application.edit" })}
                            </DialogTitle>
                            <DialogContent style={{ paddingTop: 20 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="ID"
                                            type="number"
                                            value={this.state.dialogId}
                                            onChange={(e) => this.setState({ dialogId: e.target.value })}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            disabled={this.state.dialogMode === 'edit'}
                                            inputProps={{ min: '1' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <TextField
                                            label={intl.formatMessage({ id: "name" })}
                                            value={this.state.dialogName}
                                            onChange={(e) => this.setState({ dialogName: e.target.value })}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            autoFocus
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="caption" style={{ fontWeight: 600, color: '#757575', textTransform: 'uppercase' }}>
                                            {intl.formatMessage({ id: "admin.products.billing.modes" })}
                                        </Typography>
                                        <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                                            {this.state.billingModes.map(bm => (
                                                <FormControlLabel
                                                    key={bm.id ?? bm.Id}
                                                    control={
                                                        <Checkbox
                                                            checked={(this.state.dialogAllowedBillingModes || []).includes(bm.id ?? bm.Id)}
                                                            onChange={() => this.handleToggleBillingMode(bm.id ?? bm.Id)}
                                                            color="primary"
                                                        />
                                                    }
                                                    label={bm.name ?? bm.Name ?? bm.code ?? '-'}
                                                />
                                            ))}
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.handleCloseDialog()} color="default">
                                    {intl.formatMessage({ id: "cancel" })}
                                </Button>
                                <Button onClick={() => this.handleSaveProduct()} variant="contained" style={{ backgroundColor: '#8BC34A', color: '#fff' }}>
                                    {intl.formatMessage({ id: "save" })}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* Delete Confirmation Dialog */}
                        <ConfirmActionDialog
                            title={intl.formatMessage({ id: "admin.application.delete" })}
                            message={intl.formatMessage({ id: "admin.application.delete.confirm" }, { name: this.state.deleteProductName })}
                            open={this.state.deleteDialogOpen}
                            onConfirm={() => this.handleDeleteProduct()}
                            onClose={() => this.setState({ deleteDialogOpen: false })}
                        />

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminProducts.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminProducts)));
